module.exports = __webpack_public_path__ + "static/media/ArrowBottomBlack.50840e41.svg";